<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import MousePosition from '../ol/control/MousePosition';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        data() {
            return {
                idPanel: 'mouseposition',
                className: 'ol-mouse-position',
            }
        },
        computed: {
            projections() {
                return this.$store.getters[`${this.moduleCode}/getProjectionsMap`] || [];
            },
            config() {
                return this.tool.config || {};
            },
        },
        methods: {
            addButtonMap: function(_map){
                let panel = _map.getPanel(this.posBtnMap, {'subposition': this.subPosBtnMap});
                if(panel) {
                    let ctrl = new MousePosition({
                        tipLabel: this.title,
                        className: _map.getControlClassName(this.orderClassName),
                        target: panel.getElement(this.subPosBtnMap),
                        projections: this.projections,
                        precision: 2,
                        editCoordinates: !!this.config.editCoordinates,
                        displayDMS: !!this.config.displayDMS
                    });
                    ctrl.on('change:projection', (evt) => {
                        let projection = evt.projection?.getCode() ?? _map.getProjection().getCode();
                        this.$store.dispatch(`setViewProjectionMap`, {projection})
                    });
                    _map.addControlOL(ctrl);
                    return ctrl;
                }
                return false;
            },
        }

    }
</script>

<style lang="scss" scoped>
</style>